module.exports = __webpack_public_path__ + "static/media/wifi rr.87883569.jpg";